/* Mell — прилага течащите промоции върху ценовите таблици.
   Данните остават с истинските цени; промоцията се налага в движение и изчезва сама,
   щом записът в Shopify изтече. Вход: window.MELL_PROMO {bid,pkg,eur,bgn} — един ред;
   window.MELL_PKG_PROMO {pct, bids?} — процент от пакетите (всичко, което не е единична процедура);
   с bids — само за процедурите, към които принадлежат тези booking_id. */
(function(){
  var P = window.MELL_PROMO, K = window.MELL_PKG_PROMO;
  if (!(P && P.bid) && !(K && K.pct > 0)) return;
  var RATE = 1.95583, F = K && K.pct > 0 ? 1 - K.pct / 100 : 1;
  var S = null;
  if (K && K.bids) { S = {}; K.bids.forEach(function(b){ S[b] = 1; }); }
  function r2(n){ return Math.round(n * 100) / 100; }
  function pkgCount(l){if(/3\s*\+\s*1/.test(l))return 4;if(/5\s*\+\s*2/.test(l))return 7;var m=(l||'').match(/(\d+)/);return m?+m[1]:1;}

  // продуктова страница (window.MELL_PRODBID: bid → {g, p:[[име, eur, bgn], ...]})
  var PB = window.MELL_PRODBID;
  if (PB) Object.keys(PB).forEach(function(bid){
    (PB[bid].p || []).forEach(function(row){
      if (P && P.bid == bid && row[0] === P.pkg) { row[3] = row[1]; row[1] = P.eur; row[2] = P.bgn; }
      else if (F < 1 && (!S || S[bid]) && pkgCount(row[0]) > 1 && row[3] == null) { row[3] = row[1]; row[1] = r2(row[1] * F); row[2] = r2(row[1] * RATE); }
    });
  });

  // страница „Цени" (window.MELL_PRICES + window.MELL_BIDS)
  var D = window.MELL_PRICES, B = window.MELL_BIDS;
  if (!D) return;
  Object.keys(D).forEach(function(handle){
    var map = (B && B[handle]) || {}, data = D[handle];
    var dims = (data.dims || []).filter(function(d){ return d !== 'package'; });
    // процедурата е в обхвата, ако някоя от зоните й е сред bids (цялата процедура — и пакетите без своя зона)
    var inScope = !S || Object.keys(map).some(function(k){ return S[map[k]]; });
    (data.items || []).forEach(function(it){
      var key = dims.map(function(d){ return it[d]; }).join('|');
      if (P && P.bid && map[key] === P.bid && it.package === P.pkg) {
        it.old_eur = it.eur; it.eur = P.eur; it.bgn = P.bgn;
      } else if (F < 1 && inScope && pkgCount(it.package) > 1 && it.old_eur == null) {
        it.old_eur = it.eur; it.eur = r2(it.eur * F); it.bgn = r2(it.eur * RATE);
      }
    });
  });
})();
